import React, {useEffect} from "react"
import LowHeader from "./LowHeaderContainer"
import {observer} from "mobx-react-lite"
import {UseStores} from "../../hooks/UseStores"
import {defaultGeo, URLPATHS} from "../../utils/utils"
import {useLocation} from "@reach/router"
import MapNavigation from "../../components/MapNavigation"

const LocationGroups = ({children, handleGeoUpdate}) => {
  const {locGroupStore, disStore, navStore, gtMapStore, paginationStore} = UseStores()
  const currentPage = useLocation().pathname

  useEffect(() => {
    navStore.setCurrentPage(URLPATHS.LOCATIONGROUPS)
    if (navStore.previousPage === URLPATHS.DISCOVERYBRANDS) {
      disStore.setGeoTimeObj({geo: defaultGeo})
    }
    paginationStore.resetDefault()
  }, [])

  useEffect(() => {
    if (
      locGroupStore.mapGeoObj.selected !== null &&
      currentPage === URLPATHS.LOCATIONGROUPS
    ) {
      locGroupStore.updateMapGeoRequest() //update requestIds before updating map component
      const mapParams = {
        geo: locGroupStore.locGeoTime.geo,
        categoryId: null,
        brandId: null,
        visitDuration: null,
        mapGeos: locGroupStore.mapGeos,
        showLoader: locGroupStore.showLoader,
        locationGroupId: locGroupStore.mapGeoObj.selected,
        mapPadding: {left: 500},
      }
      console.log(mapParams)
      gtMapStore.setMapObj(mapParams)
    } else if (locGroupStore.tableStates.tableDataError) {
      console.error("LocationGroups/index LINE 41: ERROR IN TABLE, MAP WILL NOT RENDER")
    }
  }, [JSON.stringify(locGroupStore.mapGeoObj)]) // potential change
  // }, [locGroupStore.mapGeoObj]); //original setup

  return (
    <div className="brands-LG-container">
      <LowHeader />
      <MapNavigation
        geoObj={locGroupStore.locGeoTime.geo}
        handleUpdate={handleGeoUpdate}
      />
      <div className="brandsPage">
        <div className="brandsLeft">{children}</div>
      </div>
    </div>
  )
}
export default observer(LocationGroups)
